module.exports = __webpack_public_path__ + "img/d87dfdb.jpg";